import { Send } from "lucide-react"
import React from "react"
import { Loader2 } from "lucide-react"
import { ArrowUpIcon, ArrowPathIcon } from '@heroicons/react/24/outline'

export function Loader() {
  return <Loader2 size={18} className="animate-spin" />
}

export default function ChatInput({ value, onChange, loading, sendMessage, isTable }) {
  const [isFocused, setIsFocused] = React.useState(false)
  

  return (
    <div className="max-w-md space-y-4 w-full animate-in fade-in slide-in-from-bottom-4 duration-1200 ease-in-out">
      <div className="w-full max-w-2xl mx-auto space-y-4">
        <div className={`
          relative bg-gray-50 rounded-2xl 
          border transition-all duration-300
          ${isFocused
            ? 'border-gray-300 bg-gray-100'
            : 'border-gray-200 hover:border-gray-300'
          }
        `}>
          <div className="flex items-end p-4">
            <div className="flex-1">
              <textarea
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault()
                    sendMessage(e)
                  }
                }}
                placeholder={isTable ? "Modify my table..." : "Describe your workflow"}
                rows={3}
                className="w-full bg-transparent text-gray-800 placeholder:text-gray-400 text-md font-normal resize-none border-0 outline-none min-h-[90px] max-h-[150px] leading-relaxed"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
              />
            </div>
            <button
              type="submit"
              onClick={(e) => sendMessage(e)}
              disabled={loading || !value.trim()}
              className={`
                ml-2 rounded-full p-2 transition-all duration-200 flex-shrink-0  
                ${loading || !value.trim()
                  ? 'text-gray-400 cursor-not-allowed bg-gray-300'
                  : 'text-gray-700 hover:bg-gray-900 bg-gray-900'
                }
              `}
            >
              {loading ? (
                <ArrowPathIcon className="h-5 w-5 animate-spin" />
              ) : (
                <ArrowUpIcon className="h-5 w-5 text-white" />
              )}
            </button>
          </div>
        </div>
    </div>
    </div>
  )
}